<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M6 12c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.941v-8c0-.367.13-.68.391-.942.261-.261.575-.392.942-.392h6c.367 0 .68.13.942.392.26.261.391.575.391.942v8c0 .366-.13.68-.391.941A1.284 1.284 0 0 1 12 12H6Zm0-1.333h6v-8H6v8Zm-2.667 4c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 13.333V4h1.333v9.333h7.334v1.334H3.333Z"
        />
    </svg>
</template>

<script setup lang="ts">
type ContentCopyIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<ContentCopyIconProps>();
</script>
